module.exports = __webpack_public_path__ + "media/images/logotype-bleu-87925958788a68c900148a170ea852c6.png";